@if (securityData) {
    <div class="card border-0 shadow-sm pt-0">
        <div class="card-header fs-5 fw-medium">Security & Permissions</div>
        <div class="card-body">
            <div class="row mb-2">
                <div class="col-12">
                    <span class="fw-medium me-2">Status:</span>
                    <span class="badge" [ngClass]="getStatusBadgeClass(securityData.status)">{{ securityData.status }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="form-label">User role(s)</label>
                    <dx-tag-box
                        [(value)]="securityData.roles"
                        [dataSource]="rolesDataSource"
                        displayExpr="name"
                        valueExpr="name"
                        [showClearButton]="true"
                        [searchEnabled]="true"
                        stylingMode="filled"
                        (onValueChanged)="onRolesChange()"
                        [readOnly]="isReadOnly"
                    ></dx-tag-box>
                    <div class="form-text">Select all that apply</div>
                </div>
            </div>
        </div>
    </div>
}
